
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class CloudFormationsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (400 + layerIndex * 200) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing * 1.5);
        const curTime = time * 0.1 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        for (let x = x1; x <= x2; x += spacing * 1.5) {
            for (let y = y1; y <= y2; y += spacing * 1.5) {
                const offX = Math.sin(curTime + x * 0.01) * 100;
                const r = spacing * (0.8 + this.pseudoRandom(x + y) * 0.7) * scale;
                
                const draw = () => {
                    const grad = ctx.createRadialGradient(x + offX, y, 0, x + offX, y, r);
                    grad.addColorStop(0, pc.color);
                    grad.addColorStop(0.6, pc.color);
                    grad.addColorStop(1, 'transparent');
                    
                    ctx.fillStyle = grad;
                    ctx.beginPath();
                    ctx.ellipse(x + offX, y, r, r * 0.5, 0, 0, Math.PI * 2);
                    ctx.fill();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
